import { BaseInputFieldFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import React from "react";

const SubjectFilter = ({ label = "l.searchFilter.subject", ...others }: FilterLabelProps) => {
  return <BaseInputFieldFilter label={label} fieldName={"subject"} {...others} />;
};

export default SubjectFilter;
